module.exports = __webpack_public_path__ + "img/30_47.687acea5.png";